import { connect } from "react-redux";

import {
  clearCreatedCustomerInfo,
  createClient,
  getClientList,
  getClientShortList,
} from "../../ClientsNew/clientsActions";
import {
  clearWorkOrderBilling,
  clearWorkOrderBudget,
  clearWorkOrderId,
  createJobRequest,
  createWorkOrderBill,
  createWorkOrderBudget,
  createWorkOrderRequest,
  getWorkOrderBill,
  getWorkOrderBudget,
  updateJobRequest,
  updateWorkOrder,
  updateWorkOrderBill,
  updateWorkOrderBudget,
} from "../../WorkOrderNew/workOrderActions";
import CreateProjectModal from "./CreateProjectModal";

const mapStateToProps = state => ({
  clientList: state.client.clientList,
  clientShortList: state.client.clientShortList,
  selectedOrganization: state.organization.selectedOrganization,
  createdWorkOrderId: state.workorder.createdWorkOrderId,
  createWorkOrderIsLoading: state.workorder.createWorkOrderIsLoading,
  createdClientId: state.client.createdClientId,
  createdClientInfo: state.client.createdClientInfo,
});

const mapDispatchToProps = dispatch => ({
  getClientList: details => dispatch(getClientList({ ...details })),
  getClientShortList: details => dispatch(getClientShortList({ ...details })),
  createClient: details => dispatch(createClient({ ...details })),
  clearCreatedCustomerInfo: () => dispatch(clearCreatedCustomerInfo()),
  createWorkOrderRequest: details =>
    dispatch(createWorkOrderRequest({ ...details })),
  clearWorkOrderId: () => dispatch(clearWorkOrderId()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateProjectModal);
